/* eslint-disable no-unused-vars */
import React from "react";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import { Helmet } from "react-helmet";
import SheetLinks from "../../../../components/PagesComponents/Financial/CashOutFlow/Dashboard/SheetLinks.component";
import LineGraphChart from "../../../../components/PagesComponents/Financial/CashOutFlow/Dashboard/LineGraphChart.component";
import BarGraphChart from "../../../../components/PagesComponents/Financial/CashOutFlow/Dashboard/BarGraphChart.component";
import CashOutFlowPieChartOne from "../../../../components/PagesComponents/Financial/CashOutFlow/Dashboard/CashOutFlowPieChartOne.component";
import CashOutFlowPieChartTwo from "../../../../components/PagesComponents/Financial/CashOutFlow/Dashboard/CashOutFlowPieChartTwo.component";
import "../../../../styles/Pages/Financial/CashOutFlow/Dashboard/Dashboard.style.css";
import UniversalTable from "../../../../components/Universal/Tables/UniversalTable.component";
import ScrollableModal from "../../../../components/Universal/ScrollableModal.component";
import DatePicker from "../../../../components/Universal/DatePicker.component";
import CustomBill from "../../../../components/Universal/CustomBill.component";
import SearchIcon from "../../../../assets/Icons/Pages/Organizational/Management/Members/Search.svg";

const Body = ({
  columns,
  data,
  isReceiptOpen,
  setIsReceiptOpen,
  handleReceiptClick,
  lineChartData,
  donutChartData1,
  barGraphDataResidential,
  barGraphData,
  donutChartData2,
}) => {
  const [showOutFlowSheet, setShowOutFlowSheet] = React.useState(false);
  // eslint-disable-next-line no-unused-vars
  const [submittedValues, setSubmittedValues] = React.useState(null);

  if (showOutFlowSheet) {
    return (
      <section className="cashOutFlowSheets">
        <Helmet>
          <title>Cash outflow sheets</title>
          <meta
            name="description"
            content="Monitor and analyze cash inflow trends and contributions."
          />
          <meta
            name="keywords"
            content="cash outflow, financial dashboard, cash flow analysis, business finance"
          />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
        <PageHeader title={"Cash outflow sheets"} />
        <ScrollableModal
          isOpen={isReceiptOpen}
          onClose={() => setIsReceiptOpen(!isReceiptOpen)}
        >
          {isReceiptOpen && (
            <CustomBill data={submittedValues} vendorInfo={[]} />
          )}
        </ScrollableModal>
        <div
          style={{
            marginTop: "1rem",
            backgroundColor: "white",
            padding: "2rem",
            borderRadius: "10px",
          }}
          className="HistorySection"
        >
          <div className="history-header mb-1">
            <h3
              style={{
                color: "var(--grayColor)",
                fontWeight: "500",
                marginBottom: "0.5rem",
              }}
            >
              All accommodation maintenance payment history
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              className="inputs-buttons"
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                className="input"
              >
                <div className="searchInputContainer">
                  <button className="searchBtn">
                    <img src={SearchIcon} alt="Search" />
                  </button>
                  <input
                    type="text"
                    className="pageHeaderInput"
                    placeholder="Search id"
                  />
                </div>
                <DatePicker
                  label=""
                  name="date"
                  setFieldValue={() => {}}
                  placeholder={"Choose a date"}
                  errors={() => {}}
                />
              </div>
              <div style={{ display: "flex", gap: "1rem" }} className="buttons">
                <button
                  style={{
                    backgroundColor: "var(--blueColor1)",
                    borderColor: "var(--blueColor1)",
                  }}
                  onClick={() => setShowOutFlowSheet(false)}
                  className="actionBtn"
                >
                  Go to cash outflow dashboard
                </button>
                <button className="actionBtn">Download</button>
              </div>
            </div>
          </div>
          <div className="history-table">
            <UniversalTable
              columns={columns}
              data={data}
              maxBodyHeight="340px"
              openReceipt={setIsReceiptOpen}
              footer={
                <div className="Amount-Indicators">
                  <div className="indicator-group">
                    <span className="indicator-box filled-orange">
                      Total count: <span className="text-white">236</span>
                    </span>

                    <span className="indicator-box outlined-orange">
                      Due amount:{" "}
                      <span className="text-orange">₹ 2,60,560</span>
                    </span>
                  </div>

                  <div className="indicator-group">
                    <span className="indicator-box outlined-blue">
                      Total amounts:{" "}
                      <span className="text-blue-light">₹ 2,60,560</span>
                    </span>

                    <span className="indicator-box filled-blue">
                      Paid amount:{" "}
                      <span className="text-white">₹ 2,60,560</span>
                    </span>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="cashOutFlowDashboard">
      <Helmet>
        <title>Dashboard</title>
        <meta
          name="description"
          content="Monitor and analyze cash inflow trends and contributions."
        />
        <meta
          name="keywords"
          content="cash outflow, financial dashboard, cash flow analysis, business finance"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <PageHeader title={"Dashboard"} />
      <div className="Sheets">
        <SheetLinks setShowOutFlowSheet={setShowOutFlowSheet} />
      </div>
      <div className="cashOutFlowMainContainer">
        <div className="cashOutFlowGraphContainer">
          <div className="lineGraphChart">
            <LineGraphChart graphData={lineChartData} />
          </div>
          <div className="seperater-line"></div>
          <div className="barGraphChart">
            <BarGraphChart
              graphData={barGraphData}
              graphDataSecond={barGraphDataResidential}
            />
          </div>
        </div>
        <div className="cashOutFlowPieChartContainer">
          <div className="pieChart">
            <CashOutFlowPieChartOne donutChartData={donutChartData1} />
          </div>
          <div className="pieChart2">
            <CashOutFlowPieChartTwo donutChartData={donutChartData2} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
